export const ADD_SUBMISSION = 'ADD_SUBMISSION';
export const SET_IS_NEW_FORM = 'SET_IS_NEW_FORM';
export const SET_LATEST_SUBMISSIONS = 'SET_LATEST_SUBMISSIONS';
export const SET_SUBMISSION_ID = 'SET_SUBMISSION_ID';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_ERROR_STATE = 'SET_ERROR_STATE';
export const SET_BUTTON_STATE = 'SET_BUTTON_STATE';
export const FORM_NAME = 'FORM_NAME';
